import { useContext } from "react";
import { Grid2 as Grid, Stack, Typography } from "@mui/material";
import { AppContext } from "../App";
import { TextButton } from "../components/TextButton";
import { SelectedOptinalPreferences } from "../constants/steps";
import { usePostHog } from "@posthog/react";

interface OptionalField {
  label: "Modality" | "Gender" | "Language" | "Program Certification";
  subText: string;
  key: SelectedOptinalPreferences;
}

const OPTIONAL_FIELDS = [
  {
    label: "Modality",
    subText: "My provider must offer a specific modality.",
    key: "providerModalities",
  },
  { label: "Gender", subText: "My provider must be a specific gender.", key: "providerGender" },
  {
    label: "Language",
    subText: "My provider must speak a specific language.",
    key: "providerLanguage",
  },
  {
    label: "Program Certification",
    subText: "My provider must have a specific Unyte program certification (SSP, ILS, RRP).",
    key: "providerCertifications",
  },
] as OptionalField[];

export function OptionalPreferences() {
  const { selectedOptionalPreferences, setSelectedOptionalPreferences } = useContext(AppContext);
  const posthog = usePostHog();

  const handleSelection = (preference: SelectedOptinalPreferences) => {
    if (selectedOptionalPreferences.includes(preference)) {
      setSelectedOptionalPreferences(selectedOptionalPreferences.filter((item) => item !== preference)); // Deselect item
      posthog?.capture("optional_preference_toggled", { preference, action: "deselected" });
    } else {
      setSelectedOptionalPreferences([...selectedOptionalPreferences, preference]);
      posthog?.capture("optional_preference_toggled", { preference, action: "selected" });
    }
  };

  return (
    <Stack direction="column" spacing={2} alignItems="center">
      <Typography variant="h6">Are there any important “must haves” for your provider?</Typography>
      <Typography variant="subtitle1">If “no” simply select NEXT, otherwise please select any that apply:</Typography>
      <Grid container columns={{ xs: 1, sm: 2, md: 4 }} spacing={2} justifyContent="center">
        {OPTIONAL_FIELDS.map(({ label, subText, key }) => (
          <Grid
            key={key}
            size={1}
            sx={{
              "& > *": {
                width: "100%",
                height: "100%",
              },
            }}
          >
            <TextButton
              selected={selectedOptionalPreferences.includes(key)}
              onClick={() => handleSelection(key)}
              label={label}
              subText={subText}
            />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
